// How long an adult can be inactive before being signed out, and how long
// before that the warning appears. 30 minutes is a common standard for
// school systems holding student information.
export const IDLE_LIMIT_MS = 30 * 60 * 1000;
export const IDLE_WARNING_MS = 2 * 60 * 1000;
